import { supabase } from './client';

export type SignInCredentials = {
  email: string;
  password: string;
};

export type SignUpCredentials = SignInCredentials & {
  name: string;
};

export const authService = {
  // Verificar se o usuário está autenticado
  getCurrentUser: async () => {
    const { data, error } = await supabase.auth.getUser();
    
    if (error) {
      console.error("Erro ao buscar usuário:", error.message);
      return null;
    }
    
    return data.user;
  },
  
  // Fazer login com email e senha
  signIn: async ({ email, password }: SignInCredentials) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) {
      console.error("Erro no login:", error.message);
      throw error;
    }
    
    return data;
  },
  
  // Criar uma nova conta
  signUp: async ({ email, password, name }: SignUpCredentials) => {
    // 1. Registrar usuário na auth
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          name,
        },
      },
    });
    
    if (authError) {
      console.error("Erro no cadastro:", authError.message);
      throw authError;
    }
    
    // A função retorna os dados auth. 
    // Os dados do perfil serão inseridos por um trigger no banco de dados
    return authData;
  },
  
  // Logout
  signOut: async () => {
    const { error } = await supabase.auth.signOut();
    
    if (error) {
      console.error("Erro ao fazer logout:", error.message);
      throw error;
    }
    
    return true;
  },
  
  // Verificar estado atual da autenticação
  onAuthStateChange: (callback: (event: string, session: any) => void) => {
    return supabase.auth.onAuthStateChange(callback);
  },
  
  // Enviar email de recuperação de senha
  resetPassword: async (email: string) => {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    
    if (error) {
      console.error("Erro ao enviar email de recuperação:", error.message);
      throw error;
    }
    
    return true;
  },
  
  // Atualizar senha
  updatePassword: async (newPassword: string) => {
    const { error } = await supabase.auth.updateUser({
      password: newPassword
    });
    
    if (error) {
      console.error("Erro ao atualizar senha:", error.message);
      throw error;
    }
    
    return true;
  }
}; 